<template>
    <UserAccountLayout>
            <table class="orders-table">
                <thead class="orders-table__head">
                <tr>
                    <th class="orders-table__cell orders-table__head-cell orders-table__head-cell_clickable">
                        {{ trans("Order number") }}
                    </th>
                    <th class="orders-table__cell orders-table__head-cell orders-table__head-cell_clickable">
                        {{ trans("The amount") }}
                    </th>
                    <th class="orders-table__cell orders-table__head-cell">{{ trans("Date of creation") }}</th>
                    <th class="orders-table__cell orders-table__head-cell">{{ trans("Status") }}</th>
                    <th class="orders-table__cell orders-table__head-cell"></th>
                    <th class="orders-table__cell orders-table__head-cell"></th>
                </tr>
                </thead>
                <tbody>
                <tr class="orders-table__row" v-for="order in orders" :key="order.id">
                    <td class="orders-table__cell"> #{{ order.id }}</td>
                    <td class="orders-table__cell">{{ order.total }}</td>
                    <td class="orders-table__cell">{{ order.data }}</td>
                    <td class="orders-table__cell">{{ order.status }}</td>
                    <td class="orders-table__cell PersonalCabinet__order-item-content--link">
                        <a class="Link not" href="" @click.prevent="showOrder(order.id)">{{
                                trans("More detailed")
                            }}</a>
                    </td>
                    <td class="orders-table__cell PersonalCabinet__order-item-content--link"></td>
                </tr>
                </tbody>
            </table>
    </UserAccountLayout>
</template>

<script>
import UserAccountLayout from './user-account-layout.vue'
import { purchase as ga4PurchaseEvent } from '../../services/ga4Ecommerce.js'

export default {
    name: "history",
    components: {
        UserAccountLayout,
    },
    props: {
        ga4Purchase: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            orders: [],
            order: [],
            order_show: false,
        }
    },
    mounted() {
        this.getOrders()
        if (this.ga4Purchase) {
            ga4PurchaseEvent(this.ga4Purchase)
        }
    },
    methods: {
        async getOrders() {
            await axios.get('/api/v1/get-orders', {
                params: this.setParam({})
            })
            .then(data => {
                this.orders = data.data
            })
        },
        async showOrder(id) {
            await axios.get('/api/v1/get-order', {
                params: this.setParam({
                    order: id,
                })
            })
            .then(data => {
                this.$parent.$refs.air.order = data.data
                this.$parent.$refs.air.order_show = true
            })
        }
    }
}
</script>

<style scoped>

</style>
